import { FieldNormalizer } from '../types';

export default class ListFieldNormalizer {
  #normalizer: FieldNormalizer;

  constructor(normalizer: FieldNormalizer) {
    this.#normalizer = normalizer;
  }

  normalize(value: unknown[] = []) {
    const values = value || [];
    return values.map(this.#normalizer.normalize);
  }

  reverseNormalize(value: unknown[] = []) {
    const values = value || [];
    return values.map(this.#normalizer.reverseNormalize);
  }
}
